import React, { createContext, useState, useContext, useCallback } from 'react';

const SidebarContext = createContext();

export function SidebarProvider({ children }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // État combiné pour déterminer si la sidebar est étendue
  const isExpanded = !isCollapsed || isHovered || isMobileMenuOpen;

  // Utilisation de useCallback pour stabiliser les fonctions
  const handleSetCollapsed = useCallback((value) => {
    setIsCollapsed(prev => {
      if (prev !== value) {
        return value;
      }
      return prev;
    });
  }, []);

  const handleSetHovered = useCallback((value) => {
    setIsHovered(prev => {
      if (prev !== value) {
        return value;
      }
      return prev;
    });
  }, []);

  const handleSetMobileMenuOpen = useCallback((value) => {
    setIsMobileMenuOpen(prev => {
      if (prev !== value) {
        return value;
      }
      return prev;
    });
  }, []);

  return (
    <SidebarContext.Provider value={{ 
      isCollapsed, 
      setIsCollapsed: handleSetCollapsed,
      isHovered,
      setIsHovered: handleSetHovered,
      isMobileMenuOpen,
      setIsMobileMenuOpen: handleSetMobileMenuOpen,
      isExpanded
    }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within SidebarProvider');
  }
  return context;
}
